import { render, staticRenderFns } from "./OptixPublishToPlatformModal.vue?vue&type=template&id=13ea9eef&scoped=true"
import script from "./OptixPublishToPlatformModal.vue?vue&type=script&lang=js"
export * from "./OptixPublishToPlatformModal.vue?vue&type=script&lang=js"
import style0 from "./OptixPublishToPlatformModal.vue?vue&type=style&index=0&id=13ea9eef&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ea9eef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ea9eef')) {
      api.createRecord('13ea9eef', component.options)
    } else {
      api.reload('13ea9eef', component.options)
    }
    module.hot.accept("./OptixPublishToPlatformModal.vue?vue&type=template&id=13ea9eef&scoped=true", function () {
      api.rerender('13ea9eef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/OptixPublishToPlatformModal.vue"
export default component.exports